import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import "./Legal.scss";

const Legal = ({
  sections = [],
  defaultSection = null,
  basePath = "/legal",
}) => {
  const { section } = useParams();
  const navigate = useNavigate();
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const currentSection =
    sections.find((item) => item.source === section) ||
    defaultSection ||
    sections[0];

  useEffect(() => {
    if (!section || !sections.some((item) => item.source === section)) {
      navigate(`${basePath}/${currentSection.source}`, { replace: true });
    }
  }, [section, sections, navigate, currentSection, basePath]);

  const handleDropdownToggle = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  return (
    <div className="legal">
      <div className="lgl-cover">
        <div className="lgl-header">{currentSection?.name}</div>
      </div>

      <div className="legal-menu">
        <button className="dropdown-toggle" onClick={handleDropdownToggle}>
          <p className={`drp-bullet ${isDropdownOpen ? "open" : ""}`}>&lt;</p>
          {currentSection?.name}
        </button>

        {isDropdownOpen && (
          <div className="dropdown-menu">
            {sections.map((item, index) => (
              <Link
                key={index}
                to={`${basePath}/${item.source}`}
                onClick={() => setDropdownOpen(false)}
              >
                {item.name}
              </Link>
            ))}
          </div>
        )}

        <div className="legal-links">
          {sections.map((item, index) => (
            <Link key={index} to={`${basePath}/${item.source}`}>
              {item.name}
            </Link>
          ))}
        </div>
      </div>

      <div className="legal-content">{currentSection?.text}</div>
    </div>
  );
};

export default Legal;
